import { render, staticRenderFns } from "./AccessToken.vue?vue&type=template&id=2b02d8a6&scoped=true"
import script from "./AccessToken.vue?vue&type=script&lang=js"
export * from "./AccessToken.vue?vue&type=script&lang=js"
import style0 from "./AccessToken.vue?vue&type=style&index=0&id=2b02d8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b02d8a6",
  null
  
)

export default component.exports